/* eslint-disable no-console */
/* eslint-disable no-alert */
import * as axios from 'axios';
import PRICING_API_URL from '../../constants/pricing/apiUrl';

const ForumApi = {
  getForumData: async (page) => {
    const response = await axios({
      method: 'post',
      url: `${new URL(PRICING_API_URL)}/forum/head`,
      data: {
        host: window.location.host,
        url: `cost-to-make-an-app/${page}`,
      },
    });
    if (response.status >= 200 && response.status <= 300) {
      return response.data;
    }
    throw new Error(response.error);
  },
};
export default ForumApi;
